﻿export function isNullOrWhitespace(input?: string | null) {
    return !input || !input.trim();
}

export function setFirstLetterToLowerCase(value: string) {
    return value.charAt(0).toLowerCase() + value.slice(1);
}

export function isEmptyStringOrTruthy(value?: string) {
    return value || value === "";
}

// Flattens rich-text HTML to plain text for surfaces that show a description as text (e.g. a table cell),
// so stored markup like <p>…</p> never leaks as visible tags.
export function htmlToPlainText(html: string | undefined | null): string {
    if (!html) return "";
    const container = document.createElement("div");
    container.innerHTML = html;
    return (container.textContent ?? "").trim();
}

export function removeSearchOperatorCharacters(text: string | undefined): string | undefined {
    if (!text) return text;

    return text
        .replace(/["*?+[\]{}|\\^~$]/g, "")
        .replace(/\s+/g, " ")
        .trim();
}
